import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Modal } from "react-bootstrap";
import deepCopyObject from "../../../utils/deepCopyObject";

function FilterPlans(props) {
    const router = useRouter();

    const selectedFilters = props.selectedFilters;
    const setselectedFilters = props.setselectedFilters;

    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            console.log("props.allPlansFeatures");
            console.log(props.allPlansFeatures);
        }
    }, [props.allPlansFeatures]);

    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            console.log("selectedFilters change");
            console.table(selectedFilters);
            console.log(selectedFilters);
        }
    }, [selectedFilters]);

    function addSelected(category, value) {
        const newSelected = deepCopyObject(selectedFilters);
        let categorySelectedList = selectedFilters[category];
        categorySelectedList.push(value);
        newSelected[category] = categorySelectedList;
        setselectedFilters(newSelected);
    }

    function removeSelected(category, value) {
        const newSelected = deepCopyObject(selectedFilters);
        let categorySelectedList = selectedFilters[category].filter(
            (v) => v !== value
        );
        newSelected[category] = categorySelectedList;
        setselectedFilters(newSelected);
    }

    function handleChange(e, category) {
        if (selectedFilters[category].includes(e.target.value)) {
            removeSelected(category, e.target.value);
        } else {
            // add
            addSelected(category, e.target.value);
        }
    }

    function handleClose() {
        props.setfilterOpen(false);
        props.updatePlans();
    }

    function handleReset() {
        props.resetFilters();
    }

    function onSubmit() {
        props.setfilterOpen(false);
        router.push({
            pathname: "/plans",
            query: selectedFilters,
            shallow: true,
        });
    }

    return (
        <div>
            <Modal show={props.show} onHide={handleClose}>
                <Modal.Header>
                    <h5
                        className="modal-title text-center"
                        id="filterModalLabel"
                    >
                        Filter Plans
                    </h5>
                    <button
                        type="button"
                        className="close pb-0"
                        aria-label="Close"
                        onClick={handleClose}
                    >
                        <span
                            className="font-size-22"
                            aria-hidden="true"
                            style={{ fontSize: "2.4rem" }}
                        >
                            ×
                        </span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12">
                        <div className="text-muted">
                            <small>PLAN TYPE</small>
                        </div>

                        {Object.entries(props.allPlansFeatures.house_type).map(
                            (feature, idx) => {
                                const featureName = feature[0];
                                const featureValue = feature[1];

                                return (
                                    <div
                                        className="row no-gutters pt-2"
                                        key={idx}
                                    >
                                        <div className="flex-fill">
                                            <div className="custom-control custom-control-alternative custom-checkbox">
                                                <input
                                                    className="custom-control-input"
                                                    name="house_type"
                                                    value={featureName}
                                                    id={`${featureValue}of${featureName}`}
                                                    type="checkbox"
                                                    checked={selectedFilters.house_type.includes(
                                                        featureName
                                                    )}
                                                    onChange={(event) =>
                                                        handleChange(
                                                            event,
                                                            "house_type"
                                                        )
                                                    }
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor={`${featureValue}of${featureName}`}
                                                >
                                                    <span className="font-size-10 text-capitalize">
                                                        {featureName}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div>
                                            {/* <span className="badge badge-gray-600 font-size-9 px-2">
                                                {featureValue}
                                            </span> */}
                                        </div>
                                    </div>
                                );
                            }
                        )}
                    </div>

                    <div className="col-md-12 pt-3">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="text-muted">
                                    <small>BEDROOMS</small>
                                </div>

                                {/* list  */}
                                {Object.entries(
                                    props.allPlansFeatures.bedrooms
                                ).map((feature, idx) => {
                                    const featureName = feature[0];
                                    const featureValue = feature[1];
                                    return (
                                        <div
                                            className="row no-gutters pt-2"
                                            key={idx}
                                        >
                                            <div className="flex-fill">
                                                <div className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                        className="custom-control-input"
                                                        name="bedrooms"
                                                        value={featureName}
                                                        id={`${featureValue}of${featureName}-bedrooms`}
                                                        type="checkbox"
                                                        checked={selectedFilters.bedrooms.includes(
                                                            featureName
                                                        )}
                                                        onChange={(event) =>
                                                            handleChange(
                                                                event,
                                                                "bedrooms"
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor={`${featureValue}of${featureName}-bedrooms`}
                                                    >
                                                        <span className="font-size-10 text-capitalize">
                                                            {featureName}{" "}
                                                            {featureName > 1
                                                                ? "Bedrooms"
                                                                : "Bedroom"}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div>
                                                {/* <span className="badge badge-gray-600 font-size-9 px-2">
                                                    {featureValue}
                                                </span> */}
                                            </div>
                                        </div>
                                    );
                                })}
                                {/* end list  */}
                            </div>
                            <div className="col-md-6">
                                <div className="text-muted">
                                    <small>BATHROOMS</small>
                                </div>
                                {/* list  */}
                                {Object.entries(
                                    props.allPlansFeatures.bathrooms
                                ).map((feature, idx) => {
                                    const featureName = feature[0];
                                    const featureValue = feature[1];
                                    return (
                                        <div
                                            className="row no-gutters pt-2"
                                            key={idx}
                                        >
                                            <div className="flex-fill">
                                                <div className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                        className="custom-control-input"
                                                        name="bathrooms"
                                                        value={featureName}
                                                        id={`${featureValue}of${featureName}-bathrooms`}
                                                        type="checkbox"
                                                        checked={selectedFilters.bathrooms.includes(
                                                            featureName
                                                        )}
                                                        onChange={(event) =>
                                                            handleChange(
                                                                event,
                                                                "bathrooms"
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor={`${featureValue}of${featureName}-bathrooms`}
                                                    >
                                                        <span className="font-size-10 text-capitalize">
                                                            {featureName}{" "}
                                                            {featureName > 1
                                                                ? "Bathrooms"
                                                                : "Bathroom"}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div>
                                                {/* <span className="badge badge-gray-600 font-size-9 px-2">
                                                    {featureValue}
                                                </span> */}
                                            </div>
                                        </div>
                                    );
                                })}
                                {/* end list  */}
                            </div>
                        </div>
                        <div className="row no-gutters">
                            <div className="col-12 pt-3 pb-0 bordered-cont border-gray-300"></div>
                        </div>
                    </div>
                    <div className="col-md-12 pt-3">
                        <div className="text-muted">
                            <small>MINIMUM PLOT SIZE</small>
                        </div>

                        {/* list  */}
                        {Object.entries(
                            props.allPlansFeatures.minimum_plot_size
                        ).map((feature, idx) => {
                            const featureName = feature[0];
                            const featureValue = feature[1];
                            return (
                                <div className="row no-gutters pt-2" key={idx}>
                                    <div className="flex-fill">
                                        <div className="custom-control custom-control-alternative custom-checkbox">
                                            <input
                                                className="custom-control-input"
                                                name="minimum_plot_size"
                                                value={featureName}
                                                id={`${featureValue}of${featureName}`}
                                                type="checkbox"
                                                checked={selectedFilters.minimum_plot_size.includes(
                                                    featureName
                                                )}
                                                onChange={(event) =>
                                                    handleChange(
                                                        event,
                                                        "minimum_plot_size"
                                                    )
                                                }
                                            />
                                            <label
                                                className="custom-control-label"
                                                htmlFor={`${featureValue}of${featureName}`}
                                            >
                                                <span className="font-size-10 text-capitalize">
                                                    {featureName}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        {/* <span className="badge badge-gray-600 font-size-9 px-2">
                                            {featureValue}
                                        </span> */}
                                    </div>
                                </div>
                            );
                        })}
                        {/* end list  */}

                        <div className="row no-gutters">
                            <div className="col-12 pt-3 pb-0 bordered-cont border-gray-300"></div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-gray-800 btn-block"
                        onClick={handleReset}
                    >
                        CLEAR FILTERS
                    </button>
                    <button
                        type="button"
                        id="submit-filter"
                        className="btn btn-sm btn-primary btn-block"
                        onClick={onSubmit}
                    >
                        RESULTS
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default FilterPlans;
